import React from 'react'

export const HighlightIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.13184 1.38477C7.26164 1.08164 7.67287 1.06298 7.83789 1.32812L7.86816 1.38477L9.10059 4.2666C9.31898 4.77682 9.78463 5.13526 10.3281 5.21875L10.4375 5.23145L13.5703 5.49512C13.9017 5.52319 14.0478 5.91242 13.8428 6.15137L13.7969 6.19727L11.4297 8.22852C11.0044 8.59351 10.8032 9.15233 10.8926 9.7002L10.9141 9.80957L11.627 12.8369C11.7029 13.1596 11.3805 13.4195 11.0898 13.3008L11.0322 13.2725L8.32129 11.6504C7.87887 11.3859 7.34041 11.3534 6.87402 11.5518L6.67871 11.6504L3.96777 13.2725C3.68327 13.4426 3.33723 13.2133 3.3623 12.9004L3.37305 12.8369L4.08594 9.80957C4.21441 9.26399 4.04759 8.69361 3.65234 8.30371L3.57031 8.22852L1.20312 6.19727C0.950644 5.98057 1.0601 5.57866 1.36621 5.50488L1.42969 5.49512L4.5625 5.23145C5.11553 5.18496 5.60203 4.85564 5.85254 4.36621L5.89941 4.2666L7.13184 1.38477Z"
      fill="white"
      stroke="#6B6B6B"
      strokeWidth="1.2"
    />
  </svg>
)
